import axios from "axios";
import BaseApi from "./base";
import {
  GET_ORDER,
  GET_SIMILAR_ORDERS,
  SAVE_ORDER,
  CHANGE_ORDER_COUNTRY,
  SAVE_ORDER_CALL_LOG,
  COMPLETE_ORDER_CALL,
  GET_ORDER_PRODUCTS,
  CREATE_REQUEST,
  ORDER_SEND_INFO,
  CREATE_ORDER,
  GET_AUDIT_INFO,
  GET_SCRIPT,
  GET_SCRIPTS_BY_COUNTRY,
  GET_PHONE_DATA,
  GET_ORDER_RECORDS,
  RESEND_PAYMENT_LINK,
  GET_PAYMENT_LINKS_LIFETIME,
  GET_ORDER_BY_PHONE,
  GET_DELIVERY_ORDER_BY_ID,
  GET_DELIVERY_ORDER,
  SEND_INCOME_CALL_NUMBER
} from '../constants/api';
const CancelToken = axios.CancelToken;
let cancel;

export default class extends BaseApi {
  static get(id) {
    const PATH = id ? `${GET_ORDER}?order_id=${id}` : GET_ORDER;
    return axios.get(PATH, {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
  }

  static cancelGetOrder() {
    cancel();
  }

  static resolveIncomingCall(payload) {
    return axios.post('order/incoming-call-context', this.stringify(payload));
  }

  static getSimilarOrders(id) {
    return axios.get(`${GET_SIMILAR_ORDERS}/${id}`);
  }

  static save(data, orderId) {
    return axios.post(SAVE_ORDER + "/" + orderId, this.stringify(data));
  }

  static create(data) {
    return axios.post(CREATE_ORDER, this.stringify(data));
  }

  static changeOrderCountry(data, id) {
    return axios.post(CHANGE_ORDER_COUNTRY + "/" + id, this.stringify(data));
  }

  static saveOrderCallLog(data) {
    return axios.post(SAVE_ORDER_CALL_LOG, this.stringify(data));
  }
  static completeOrderCall(id) {
    return axios.post(COMPLETE_ORDER_CALL + "/" + id);
  }

  static createRequest(data) {
    return axios.post(CREATE_REQUEST, this.stringify(data));
  }

  static getOrderProducts(id) {
    return axios.get(GET_ORDER_PRODUCTS + "/" + id);
  }

  static sendOrderInfo(id) {
    return axios.get(ORDER_SEND_INFO + "/" + id);
  }

  static getAuditInfo(id) {
    return axios.get(GET_AUDIT_INFO + "/" + id);
  }

  static getScript(id) {
    return axios.get(GET_SCRIPT + '/' + id);
  }

  static getScriptsByCountry(id) {
    return axios.get(GET_SCRIPTS_BY_COUNTRY + '/' + id);
  }
                      
  static getPhoneData(id) {
    return axios.get(GET_PHONE_DATA + '/' + id);
  }

  static getOrderAttemptsDataByOperator(payload) {
    return axios.get(GET_ORDER_RECORDS , {
      params: {
        order_id: payload.order_id,
      }
    });
  }

  static resendPaymentLink(id) {
    return axios.get(RESEND_PAYMENT_LINK + "/" + id);
  }

  static getPaylinksLifetime(data) {
    return axios.post(GET_PAYMENT_LINKS_LIFETIME, this.stringify(data));
  }

  static getDeliveryOrder(payload) {
    return axios.get(GET_DELIVERY_ORDER, {
      params: {
        phoneNumber: payload.phoneNumber,
        orderId: payload.orderId,
      }
    });
  }

  static sendIncomeCallNumber(payload) {
    let queueString = '/?phone=' + payload.phoneNumber;
    if (payload.assignToUser !== undefined) {
      queueString += '&assign_to_user=' + payload.assignToUser;
    }
    return axios.get(SEND_INCOME_CALL_NUMBER + queueString);
  }
}
